export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
  PRIMARY: 'primary',
};
